var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import { exceptionModal } from "../../services/misc.functions";
import { modalServiceSubject } from "../../services/modal.service";
import { isMobile } from "../../App";
var ReportLine = function () {
    var _a = useState(null), captchaValue = _a[0], setCaptchaValue = _a[1];
    var _b = useState(null), captchaError = _b[0], setCaptchaError = _b[1];
    function onChange(value) {
        setCaptchaValue(value);
    }
    var _c = useForm(), register = _c.register, handleSubmit = _c.handleSubmit, reset = _c.reset, getValues = _c.getValues, errors = _c.formState.errors;
    var onSubmit = function (payload) {
        if (captchaValue != null) {
            setCaptchaError('Lütfen Doldurunuz.');
            return;
        }
        payload.captchaValue = captchaValue;
        var report_submit_button = document.getElementById("report-submit-button");
        if (report_submit_button) {
            report_submit_button.disabled = true;
        }
        api.start('post', env.accounting_api + '/misc/api/create-unauthorized-draw/', payload, true)
            .then(function (res) {
            if (res && res.status) {
                reset({ detail: "", address: "", subject: -1 });
                modalServiceSubject.next({
                    case: "success",
                    title: "Teşekkürler",
                    content: "<p class=\"text-center\">".concat(res.message, "</p>"),
                    confirm: {
                        cancel: {
                            class: "btn btn-success",
                            label: "Tamam",
                        },
                    },
                });
            }
            else {
                modalServiceSubject.next({
                    case: "danger",
                    title: "Hata!",
                    content: "<p class=\"text-center\">".concat(res.message, "</p>"),
                    confirm: {
                        cancel: {
                            class: "btn btn-danger",
                            label: "Tamam",
                        },
                    },
                });
            }
        }).catch(function (e) {
            exceptionModal(e);
        }).finally(function () {
            if (report_submit_button) {
                report_submit_button.disabled = false;
            }
        });
    };
    return (_jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-md-12 col-sm-12 col-lg-12 mx-auto mt-4" }, { children: _jsxs("div", __assign({ className: "card mb-4 rounded-4 support-ticket-form  ".concat(isMobile ? 'px-0' : 'px-5') }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", __assign({ className: "text-wrap" }, { children: "\u0130zinsiz \u00C7ekili\u015F, Yasa D\u0131\u015F\u0131 Bahis ve \u015Eans Oyunlar\u0131 \u0130hbar Hatt\u0131" })) })), _jsx("div", __assign({ className: "card-body" }, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsx("div", __assign({ className: "row mt-2" }, { children: _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("label", { children: "Konu" }), _jsxs("select", __assign({ className: "form-select" }, register("subject", { required: true }), { children: [_jsx("option", __assign({ value: -1 }, { children: "Konu Se\u00E7iniz" })), _jsx("option", __assign({ value: 0 }, { children: "\u0130zinsiz \u00C7ekili\u015Fler" })), _jsx("option", __assign({ value: 1 }, { children: "Yasa D\u0131\u015F\u0131 Bahis" }))] })), (errors.subject && getValues('subject') == -1) && (_jsx("div", __assign({ className: "invalid-feedback d-block" }, { children: "L\u00FCtfen Bir Konu Se\u00E7iniz" })))] })) })), _jsx("div", __assign({ className: "row mt-2" }, { children: _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("label", { children: "Adres / Sosyal Medya Hesaplar\u0131" }), _jsx("input", __assign({ type: "text", className: "form-control" }, register("address", { required: true }))), errors.address && (_jsx("div", __assign({ className: "invalid-feedback d-block" }, { children: "Adres / Sosyal Medya Hesaplar\u0131 gereklidir." })))] })) })), _jsx("div", __assign({ className: "row mt-2" }, { children: _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("label", __assign({ className: "login-label" }, { children: "Detayl\u0131 Bilgi" })), _jsx("textarea", __assign({ className: "form-control" }, register("detail", {
                                                required: true,
                                            }))), errors.detail && (_jsx("div", __assign({ className: "invalid-feedback d-block" }, { children: "Detayl\u0131 Bilgi gereklidir." })))] })) })), _jsxs("div", __assign({ className: "row mt-2" }, { children: [_jsx(ReCAPTCHA, { sitekey: "6Lful3IpAAAAABXS04aT2S8h_KrC5ktGP1gG0TR9", onChange: onChange }), captchaError && (_jsx("div", __assign({ className: "invalid-feedback d-block" }, { children: captchaError })))] })), _jsx("button", __assign({ className: "btn btn-success mt-2 btn-lg", id: "report-submit-button" }, { children: "G\u00F6nder" }))] })) }))] })) })) })));
};
export default ReportLine;
